import { useCallback, useContext } from "react";
import { Context } from "../context/Context";
import { integrationLabel, normalizeIntegrationKey } from "./integrations";

// Display label for an app in `lang`. Accepts several candidate values (e.g.
// a snapshot's `app` then `name`): the first known app is shown with its
// registry label; otherwise the first non-empty value is shown as is.
export function appDisplayLabel(lang, ...candidates) {
  const key = candidates.map(normalizeIntegrationKey).find(Boolean);
  if (key) return integrationLabel(key, lang);
  const raw = candidates.find((value) => value !== null && value !== undefined && String(value).trim() !== "");
  return raw === undefined ? "" : String(raw);
}

// Returns `(...candidates) => label` for the current UI language (registry
// labels from utils/integrations.js). Screens rendered outside the app
// context (e.g. Arabic-only cashier screens in tests) use `fallbackLang`.
export function useAppLabel(fallbackLang = "ar") {
  const lang = useContext(Context)?.lang || fallbackLang;
  return useCallback((...candidates) => appDisplayLabel(lang, ...candidates), [lang]);
}
